import React from "react"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"
import { FaFacebookF, FaTwitter } from "react-icons/fa"
import PhoneIcon from "../../images/iconmonstr-phone-6.svg"
import ContactBar from "../ContactBars/ContactBar"
import FacilityContext from "../PageLayout"

type PropTypes = {
  info: any
  className?: string
}

type SocialIconTypes = {
  media: "facebook" | "twitter"
}

const HeaderContactWrapper = styled.div`
  display: none;
  align-items: center;
  position: absolute;
  top: 28px;
  right: 0;
  @media screen and (min-width: 1024px) {
    display: flex;
  }
`

const SocialIconStyles = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${colors("green", "lnk")};
  font-size: 14px;
  line-height: 1em;
  transition: all 0.25s;
  margin-right: 19px;
  &,
  &:hover {
    text-decoration: none;
    color: white;
  }
  &:hover {
    background-color: ${colors("green", "lnkhlt")};
  }
`

const HeaderContact: React.FC<PropTypes> = ({ info, className }) => {
  const SocialIcon: React.FC<SocialIconTypes> = ({ media }) => {
    const url =
      media === "facebook"
        ? info.facilityInfo.facebookUrl
        : media === "twitter"
        ? info.facilityInfo.twiterUrl
        : null

    return media === "facebook" || media === "twitter" ? (
      <SocialIconStyles
        href={url}
        aria-label={
          media === "facebook"
            ? "Visit us on facebook"
            : media === "twitter"
            ? "Visit us on twitter"
            : null
        }
      >
        {media === "facebook" ? (
          <FaFacebookF />
        ) : media === "twitter" ? (
          <FaTwitter />
        ) : null}
      </SocialIconStyles>
    ) : null
  }

  return (
    <HeaderContactWrapper id="Header-contact" className={className}>
      {info.facilityInfo.facebookUrl && <SocialIcon media="facebook" />}
      {info.facilityInfo.twitterUrl && <SocialIcon media="twitter" />}
      <ContactBar icon={<PhoneIcon />} size="sm">
        {info.facilityInfo.phone}
      </ContactBar>
    </HeaderContactWrapper>
  )
}

export default HeaderContact
